module.exports = __webpack_public_path__ + "img/f009808.jpg";